<script>
import { VSlider } from 'vuetify/lib';
export default VSlider;
</script>
